import type { ReactNode } from 'react';

export interface ScreenReaderLabelProps {
  /** Referenced by the labelled element's `aria-labelledby`. */
  id: string;
  children: ReactNode;
}

/**
 * Visually hidden accessible name for labels that carry personal data (emails,
 * names, creator handles, discount codes, filenames).
 *
 * Use it through `aria-labelledby` instead of putting that data in `aria-label`:
 * session recorders such as Microsoft Clarity mask page text but upload
 * attribute values as-is, so the same words are private here and exposed in an
 * attribute (issue #727). Screen readers announce exactly the same name.
 *
 * `hidden`, not `sr-only`: a node referenced by aria-labelledby still names its
 * element when hidden, but it is not read a second time, and it does not leak
 * into the name of a clickable ancestor that is named by its content.
 */
export function ScreenReaderLabel({ id, children }: ScreenReaderLabelProps) {
  return (
    <span id={id} hidden>
      {children}
    </span>
  );
}
